import React from 'react';
import { AdminRouteName } from '../../../CONSTANTS';
import TransactionTableRecords from '../TransactionTableRecord';

const SuccessfulTransaction = () => (
  <div className="transaction-root-cover"><TransactionTableRecords hasNameAndImage defaultUrl={AdminRouteName.successfulTransactionRoute} tabStatus="success" toggleStorageId="successful-transaction-table-col" recordPermission="can-view-successful-transaction" /></div>
);
export default SuccessfulTransaction;
